import React, { useEffect, useState, useReducer } from "react";
import { useTranslation } from 'react-i18next';
import { useMediaQuery } from 'react-responsive';
import Title from '../../../pageTitle/default.js';
import { useStoreState, useStoreDispatch, APP_STORE_ACTION } from '../../../../common/storeContext.js';
import { GLOBAL_BUCKET, TENANT_BUCKET } from '../../../../common/constants.js';
import { useMiddletier } from "../../../../common/middletier.js";
import Loading from '../../../../components/Loading.js';
import { useNavigate } from "react-router-dom";
import { MdOutlineKeyboardArrowUp,MdOutlineKeyboardArrowDown } from "react-icons/md";
import ImageWithPlaceholder from '../../../../components/ImageWithPlaceholder'

const ORDER_HISTORY_ACTION = {
    SET_ORDER_HISTORY: 'SET_ORDER_HISTORY',
}

const initialOrderHistoryData = {
    orderHistory: [],
}

const orderHistoryReducer = (state, action) => {
    switch (action.type) {

        case ORDER_HISTORY_ACTION.SET_ORDER_HISTORY: {
            return { ...state, orderHistory: action.payload };
        }

        default: {
            throw new Error(`Unhandled action type: ${action.type}`)
        }
    }
}


const OrderHistory = () => {
    const appDispatch = useStoreDispatch()
    const appState = useStoreState()
    const { t, i18n } = useTranslation();
    const [showBankingModal, setShowBankingModal] = useState();
    const [orderHistoryState, orderHistoryDispatch] = useReducer(orderHistoryReducer, initialOrderHistoryData)
    const { query, mutation } = useMiddletier();
    const [isLoading, setLoading] = useState(false);
    const [disabledSubmit, setDisabledSubmit] = useState(true)
    const navigate = useNavigate();
    const [viewAll, setViewAll] = useState({});
   

    useEffect(() => {
        setLoading(true)
        let method = 'getMallOrder'
        if (typeof appState.user?.username !== 'undefined') {
            query({
                method,
                params: [
                    { code: 'language', graphqlType: 'String', required: true, value: i18n.resolvedLanguage },
                ],
                attributes: []

            }).then(({ data }) => {
                setLoading(false)

                const groups = data[method].reduce((acc, item) => {
                    const key = item.mall_order;
                    if (!acc[key]) {
                        acc[key] = [];
                    }
                    acc[key].push(item);
                    return acc;
                }, {});

                const initialViewStates = Object.keys(groups).reduce((acc, key) => {
                    acc[key] = false;
                    return acc;
                }, {});
                setViewAll(initialViewStates);

                orderHistoryDispatch({ type: ORDER_HISTORY_ACTION.SET_ORDER_HISTORY, payload: groups })



            }).catch((error) => {
                setLoading(false)
                console.log('error: ', error)
                if (error?.networkError?.statusCode === 401) {
                    appDispatch({ type: APP_STORE_ACTION.UNAUTHENTICATED })
                } else {
                    appDispatch({
                        type: APP_STORE_ACTION.SHOW_ALERT,
                        payload: { description: error.message.toString(), typeAlert: 'error' }
                    });
                }
            })
        }

    }, [i18n, appState.user?.username, appDispatch, query])


    const isDesktopOrLaptop = useMediaQuery({
        query: '(min-width: 992px)'
    })

    const toggleViewMore = (orderId) => {
        setViewAll(prev => ({ ...prev, [orderId]: !prev[orderId] }));
    };

    return (
        <>
            <div className="orderHistory_body">

                {isDesktopOrLaptop ?
                    <div className="font_h2 color_primary wallet_container_title">{t('order_history')}</div> :
                    <Title id={"orderHistory_title_m"} title={'order_history'} desktopToggle={false} mobileToggle={true} />}
                <div className="wallet_container_wrap">
                    <div className="orderHistory_productContainer">
                        {

                            Object.keys(orderHistoryState?.orderHistory).length > 0 ? (
                                Object.entries(orderHistoryState?.orderHistory).sort((a, b) => parseInt(b[0], 10) - parseInt(a[0], 10)).map(([orderId, items]) => (
                                    <div key={orderId} className="orderHistory_wrap">
                                        <div className="order_wrap">
                                            <div className="order_id">{t('order_id')}: {orderId}</div>
                                            <div className={`order_status ${items[0].order_status?.toLowerCase()}_color`}>{t(items[0].order_status?.toLowerCase().replace(" ", "_"))}</div>
                                        </div>
                                        {items.slice(0, viewAll[orderId] ? items.length : 1).map(order => (
                                            <div class="card_container" key={`${order.id}`}>
                                                <div class="card_wrap">
                                                    <figure class="card_image_wrap">
                                                        <ImageWithPlaceholder src={`${isDesktopOrLaptop ? (order?._desktop_image?.url) : (order?._mobile_image?.url)}`} placeholder={`https://storage.googleapis.com/tenant-images.imbaweb.com/image-loading/1x1.png`} alt={order.id?.title} />
                                                    </figure>
                                                    <div class="color_primary content_container">
                                                        <article class="card_content_wrap">
                                                            <div class="card_content_title">
                                                                {order?.name}
                                                            </div>
                                                            <div class="card_content_desc_container">
                                                                <div>{t('order_id')} : {order?.mall_order}</div>
                                                                <div>{t('quantity')} : {order.quantity}</div>
                                                                <div>{t('recipient_phone_number')} : {order?.recipient_phone_number && `+${order.recipient_phone_number}` || '-'}</div>
                                                                <div className="address_content">{t('address')} : {order?.delivery_address}</div>
                                                            </div>
                                                        </article>
                                                        <div class={`card_action_wrap ${order?.status?.toLowerCase()}_color`}>
                                                            {t(order?.status?.toLowerCase().replace(" ", "_"))}
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        ))}
                                        {items.length > 1 && (
                                            <div class="orderHistory_action">
                                                <button onClick={() => toggleViewMore(orderId)}>{viewAll[orderId] ? <>{t('view_less')} <MdOutlineKeyboardArrowUp/></> : <>{t('view_more')} <MdOutlineKeyboardArrowDown/></>}</button>
                                            </div>
                                        )}
                                    </div>
                                ))
                            ) : (
                                (!isLoading && (<div className="d-flex align-items-center justify-content-center flex-column">
                                    <img src={`${TENANT_BUCKET}/icon/noRecord.png`} alt={''} className="no_record_img" />
                                    <span className="pt-1">{t('no_record')}</span>
                                </div>))
                            )
                        }
                    </div>
                </div>

            </div>
            {isLoading && (<Loading />)}
        </>

    );




};


export default OrderHistory;
